
import { useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { useModalesStore } from "../../store";
import { subirImagenXModelo } from "../../services";
import { envVariables } from "../../helpers";

const baseUrl = envVariables.REACT_APP_API_URL;




export const useSubirAndVerImg = () => {

    
    const { id } = useParams();
    const queryClient = useQueryClient();
    const { changeEstadoModalImagen } = useModalesStore();
    
    const fileInputRef = useRef(null);
    const [tipo, setTipo] = useState(null);
    const [campo, setCampo] = useState(null);
    const [carpeta, setCarpeta] = useState(null);
    const [imagen, setImagen] = useState(null);
    const [cargando, setCargando] = useState(false);



    const handleAction = (tipo, carpeta, campo) => {
        if(carpeta) {
            setTipo(tipo);
            setCarpeta(carpeta);
            setCampo(campo);
            fileInputRef.current?.click();
        }
    };



    const handleFileChange = async(event) => {
        const file = event.target.files[0];
        if (file && tipo) {
            setCargando(true);
            await subirImagenXModelo({ id, tipo, img:file, carpeta, campo })
            queryClient.invalidateQueries({ queryKey: ['vehiculo-id'] });
            setCargando(false)
        }
    };



    const handleVerImagen = (e, carpeta, img) => {
        e.stopPropagation();
        changeEstadoModalImagen(true)
        setCarpeta(carpeta)
        setImagen(img)
    };




    const handleDescargar = async(e, carpeta, img, titulo) => {
        e.stopPropagation();
        setCargando(true);
        try {
            const url = `${baseUrl}/uploads/${carpeta}/${img}`;
            const resp = await fetch(url);

            if (!resp.ok) throw new Error("Error al descargar el archivo");

            const blob = await resp.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');

            a.style.display = 'none';
            a.href = blobUrl;
            a.download = `${titulo.toUpperCase()}`;
            document.body.appendChild(a);
            a.click();

            window.URL.revokeObjectURL(blobUrl);
            setCargando(false)
        } catch (error) {
            alert('Hubo un error al descargar.');
            setCargando(false)
        }
    }
    



    return  {
        cargando,
        carpeta,
        imagen,
        fileInputRef,

        handleAction,
        handleFileChange,
        handleVerImagen,
        handleDescargar,
    }
}